export default __webpack_public_path__ + "static/media/Manage Feeling Overwhelem.9e8ebe70.png";